export default "__VITE_ASSET__BU6LFx9P__"